import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

import { LoanStatusEnum } from "@toorak/tc-common-util-sdk";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ConfirmFormModal, LoanStage } from "@toorak/tc-common-fe-sdk";
import {
  hideLoader,
  showLoader
} from "../stores/loaderAndException/loaderAndException.action";
import {
  getDocuments,
  getPropertyOriginalValuesByLoanId
} from "../create-loan/create-loan.action";
import { RootState } from "../stores/rootReducer";
import {
  DrawRolesEnum,
  InternalRolesEnum,
  URLParamsType
} from "../utils/constants";
import { addEmptyLineItems, convertNumberToUSD } from "./BudgetReview.utils";
import { filterObjectsByTag } from "./BudgetDocs.filter";

import { ILPStore } from "../stores/ILP/ILP.reducer";
import { getListOfAssignee, setILPUserList } from "../stores/ILP/ILP.action";
import { BudgetReviewStore } from "../stores/budgetReview/budgetReview.interface";
import {
  approvalStatuses,
  budgetApproveStatusEnum,
  budgetReviewStatusEnum,
  disableStatuses,
  editableStatuses
} from "../ilp/list-view/BudgetTaskManagement";
import { convertUSDToNumber } from "../utils/formatChecks";
import {
  // setBalanceDisbursedAmount,
  setSelectedBudgetDoc,
  updateBudgetButtonInfo,
  updateBudgetChatsData,
  updateBudgetPropData,
  updateLineItemList,
  updateSelectedPropDetails
} from "../stores/budgetReview/budgetReview.reducer";
import {
  BudgetApproverStatus,
  ExtractionInProgressState,
  ExtractionProcessState,
  isLoginPartyId
} from "./BudgetReview.constant";
import {
  deleteLineItems,
  getBudgetHistory,
  getBudgetData,
  getBudgetReviewDataV2,
  getCommentsList,
  redoBudgetReview,
  updateBudgetStatusV2,
  // updateLineReduxData,
  updatePredictionStatus,
  updateStatusOnTask,
  updateBudgetLineItems,
  getUserDetails,
  updateSelectionMode,
  getRedoValidationItems,
  getPreviousVersionData,
  // lineItemResponse,
  mergeChatDetails,
  updateTotalBudgetAPI,
  reTriggerBudgetExtraction
} from "../stores/budgetReview/budgetReview.action";
import { taskNames } from "../stores/tasks/Tasks.action";
import { DocumentViewer } from "../create-loan/ttf-review/document-review/document-viewer/DocumentViewer";
import { getCookie } from "../utils/cookies";
import { usePolling } from "../custom-hooks/usePolling";
import { getConfig } from "../config/config";
import {
  buildTaskObject,
  getAssignedBy,
  getDataByLoanID,
  getPropDataByLoanID,
  handleAddCommentProceed,
  updateFieldName
} from "./LineItemsComment.util";
import { isOrigUser, isRole, isPurchasedLoansViewerReadOnly } from "../utils/AccessManagement";
// import { DrawRequestStore } from "../stores/drawRequest/drawRequest.interface";
import { getDrawRequestData } from "../stores/drawRequest/drawRequest.action";
import { delay } from "../utils/utils";
import { LazyBudgetReview } from "../utils/LazyModules";
import { getRuleEvaluationByLoanId } from "../stores/EvaluationResults/EvaluationResults.action";
import { formatPropertyResponse } from "../create-loan/CreateLoan";

export const budgetReviewStatusConst = {
  green: budgetReviewStatusEnum.Approved,
  orange: budgetReviewStatusEnum.InProgress,
  black: budgetReviewStatusEnum.LoanSubmitted
};

export function isPLDFlow() {
  const pageSource = sessionStorage.getItem("budgetReviewSource");
  if (!pageSource) return false;
  return pageSource === "PLD Page";
}

export function updateWithPrevDrawData(
  updatedLineItems: any[],
  redoItems: any[]
) {
  let balanceAmount = 0;
  const formattedData = updatedLineItems?.map((item) => {
    const prevDrawData = redoItems.filter(
      (temp: any) => temp.item.trim() === item.item.trim()
    )[0];
    const minBudgetAllowed = prevDrawData
      ? Number(prevDrawData.latestCompletion) === 100
        ? prevDrawData?.financedBudget
        : (prevDrawData?.financedBudget * prevDrawData.latestCompletion) / 100
      : 0;
    const remainingFinance =
      prevDrawData && Number(prevDrawData.latestCompletion) === 100
        ? 0
        : Number(convertUSDToNumber(item.budget)) - minBudgetAllowed;

    balanceAmount += remainingFinance;
    const tempItem = {
      ...item,
      isPrevDrawDisbursed: prevDrawData
        ? !(
            prevDrawData?.latestCompletion == 0 ||
            prevDrawData?.latestCompletion === null
          )
        : false,
      minBudgetAllowed,
      maxBudgetAllowed:
        // prevDrawData && Number(prevDrawData.latestCompletion) === 100
        //   ? prevDrawData.financedBudget
        //   :
        Number(convertUSDToNumber(item.budget)),
      latestCompletion: prevDrawData ? Number(prevDrawData.latestCompletion) : 0
    };

    return tempItem;
  });
  return { formattedData, balanceAmount };
}

function calculateRemainingAllBudget(
  totalDisbursedAmount: number,
  budgetButtonInfo: any,
  budgetReviewResponse: any
) {
  let nonRedoTotalFB = 0;
  try {
    budgetReviewResponse.budgetDocumentInfoList.forEach((item: any) => {
      if (!item.isRedoInProcess) {
        item.budgetLineItemList?.forEach((itemList: any) => {
          const oldRatio =
            convertUSDToNumber(budgetButtonInfo.financedBudgetAmount) /
            convertUSDToNumber(budgetButtonInfo.loanDetailsBudgetAmount);

          const calFB =
            convertUSDToNumber(itemList.financedBudget) == 0
              ? convertUSDToNumber(itemList.budget) * oldRatio
              : convertUSDToNumber(itemList.financedBudget);
          // console.log(
          //   budgetButtonInfo,
          //   convertUSDToNumber(itemList.financedBudget),
          //   oldRatio,
          //   convertUSDToNumber(itemList.financedBudget) == 0,
          //   convertUSDToNumber(itemList.budget) * oldRatio,
          //   nonRedoTotalFB
          // );
          nonRedoTotalFB += calFB;
        });
      }
    });
    // let newTotalBudget =
    //   budgetReviewResponse.updatedTotalRehabBudget ??
    //   budgetButtonInfo.rehabBudget;
    const totalRemainingBudget: number =
      convertUSDToNumber(budgetButtonInfo.financedBudgetAmount) -
      nonRedoTotalFB -
      totalDisbursedAmount;
    return totalRemainingBudget;
  } catch (e) {
    console.error("Error in calculate RemainingAllBudget ", e);
    return 0;
  }
}

function calculateNewFinancedBudget(
  newLineItem: any[],
  budgetReviewResponse: any,
  budgetButtonInfo: any,
  triggerRedoDocsCalculation?: boolean
) {
  let balanceAmount = 0;
  let totalRemainingBudget = 0; // total remaining for all the properties
  let totalRemainingExcelBudget = 0; // total remaining for all the properties
  const newFinancedItemList: any[] = [];
  let _totalBudget = 0;
  let totalDisbursedAmount = 0;
  newLineItem.forEach((item) => {
    const isNewLineItem =
      typeof item.budgetLineItemId === "string" &&
      item.budgetLineItemId.startsWith("tempId_");
    const FormattedBudget = Number(convertUSDToNumber(item.budget));

    const remainingFinance =
      item.minBudgetAllowed == 0 || isNewLineItem
        ? FormattedBudget
        : item.minBudgetAllowed == item.maxBudgetAllowed // 100% disbursed
        ? 0
        : FormattedBudget - Number(item.minBudgetAllowed);
    const remainingRedoFinance =
      item.minBudgetAllowed == 0 || isNewLineItem
        ? item.beforeRedobudget
        : item.minBudgetAllowed == item.maxBudgetAllowed // 100% disbursed
        ? 0
        : item.beforeRedobudget - Number(item.minBudgetAllowed);
    if (isNewLineItem) {
      _totalBudget += FormattedBudget;
      // totalDisbursedAmount = totalDisbursedAmount + 0;
    } else {
      _totalBudget += Number(item.maxBudgetAllowed);
      totalDisbursedAmount += Number(item.minBudgetAllowed);
    }
    balanceAmount += remainingFinance;
    totalRemainingExcelBudget += remainingRedoFinance;
    if (isNaN(totalDisbursedAmount)) {
      console.error(
        "Error in calculation totalDisbursedAmount",
        Number(item.minBudgetAllowed),
        item,
        totalDisbursedAmount
      );
    }
    if (isNaN(remainingFinance)) {
      console.error("Error with new calculation...", item);
      return;
    }

    newFinancedItemList.push({
      ...item,
      remainingFinance
    });
  });
  totalRemainingBudget = triggerRedoDocsCalculation
    ? totalRemainingExcelBudget // for redo excel upload, only 1 property is possible
    : calculateRemainingAllBudget(
        totalDisbursedAmount,
        budgetButtonInfo,
        budgetReviewResponse
      );
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<,
  // let totRatio = 0;
  const formatttedData =
    totalRemainingBudget === 0
      ? newFinancedItemList
      : newFinancedItemList.map((item) => {
          const remainingFinanceBudget = (
            (item.remainingFinance / balanceAmount) *
            totalRemainingBudget
          ).toFixed(2);
          // if (item.budgetLineItemId === 26779) {
          //   console.log(convertUSDToNumber(item.maxBudgetAllowed));
          // }
          const tempFB =
            Number(remainingFinanceBudget) + Number(item.minBudgetAllowed);
          let newFB;
          if (item.remainingFinance === 0) {
            // 100% disbursed & new budget is same as old
            newFB =
              typeof item.maxBudgetAllowed === "number"
                ? convertNumberToUSD(item.maxBudgetAllowed)
                : item.maxBudgetAllowed;
          } else if (
            item.maxBudgetAllowed !== item.minBudgetAllowed &&
            item.minBudgetAllowed !== 0
          ) {
            // Between 0% & 100% disbursed or 100% disbursed, but new budget increased
            newFB = tempFB;
            // triggerRedoDocsCalculation
            //   ? convertNumberToUSD(tempFB)
            //   : convertNumberToUSD(
            //       Number(remainingFinanceBudget) + item.minBudgetAllowed
            //     );
          } else {
            newFB = convertNumberToUSD(remainingFinanceBudget);
          }

          if (Number(newFB) <= 0) {
            console.error("Financed BUdget is getting ZERO for item", item);
          }
          const tempItem = {
            ...item,
            financedBudget: newFB
          };

          return tempItem;
        });
  return formatttedData;
}

export function budgetReviewInProgress(
  tasks: any,
  budgetStatusHistory: any[],
  budgetReviewStatus?: budgetReviewStatusEnum
) {
  const userId = getCookie("person_id") || "";
  const updatedTasks: any = JSON.parse(JSON.stringify(tasks));
  let assignedBy = updatedTasks?.[0]?.assignedTasks.find((task: any) =>
    [taskNames.BUDGET_REVIEW].includes(task.taskName)
  )?.assignedBy;
  if (!assignedBy || ["UnAssigned", "None"].includes(assignedBy)) {
    assignedBy = userId;
  }
  const newBudgetStatus =
    budgetReviewStatus || budgetReviewStatusEnum.InProgress;
  // budgetReviewStatus &&
  // [
  //   budgetReviewStatusEnum.DocumentMissing,
  //   budgetReviewStatusEnum.DataMismatch
  // ].includes(budgetReviewStatus)
  //   ? budgetReviewStatusEnum.ReadyForBudgetReview
  //   : budgetReviewStatusEnum.InProgress;
  const assignedTasksObj = [
    {
      op: "replace",
      taskName: "budgetReview",
      assignedBy,
      assigneePartyId: budgetStatusHistory[0].assigneePartyId,
      taskStatus: newBudgetStatus,
      taskId: budgetStatusHistory[0].taskId,
      comment: "Status Updated by System"
    }
  ];

  const payload = {
    budgetApprovalStatus: newBudgetStatus
  };
  return {
    payload,
    assignedTasksObj
  };
}

export const InternalBudgetReviewWrapper = () => {
  const dispatch = useDispatch();
  const [budgetDocs, setBudgetDocs] = useState<any[]>([]);
  const [budgetExtractionGetResponse, setBudgetExtractionGetResponse] =
    useState<any[]>([]);
  const { loanId, loanStage, loanType } = useParams<URLParamsType>() as any;
  const [extractionStatus, setExtractionStatus] = useState<any>({
    processState: "Data Loading"
  });
  const { loanDetails } = useSelector<RootState, any>(
    (state) => state.createLoanStore
  );

  const { loanEvaluationResult } = useSelector<RootState, any>(
    (state) => state.evaluationResultsStore
  );

  const { irQCVMAdminMap } = useSelector<RootState, ILPStore>(
    (state) => state.ILPStore
  );
  const propertyDetails = useSelector<RootState, any[]>(
    (state) => state.createLoanStore.loanDetails.propertyDetails
  );
  const [userIdMapping, setUserIdMapping] = useState<any>({});
  const {
    budgetStatusHistory,
    BulkBudgetSum,
    budgetReviewHeader,
    budgetApprovalHistory,
    budgetButtonInfo,
    budgetReviewResponse,
    selectedBudgetDoc,
    lineItemsList,
    isLineItemsEditDisable,
    budgetChatsData,
    budgetPropData,
    redoValidationItems
  } = useSelector<RootState, BudgetReviewStore>(
    (state) => state.budgetReviewStore
  );
  const budgetDocsSelectedFromProp = useMemo(() => {
    if (budgetDocs.length === 0 || !budgetReviewHeader?.selectedPropId) {
      return null;
    }
    return (
      budgetDocs.find((pr: any) =>
        pr.assets.find(
          (it: any) =>
            String(it.assetExternalId) ===
            String(budgetReviewHeader?.selectedPropId)
        )
      ) ?? null
    );
  }, [budgetDocs, budgetReviewHeader?.selectedPropId]);
  const budgetDocsSelected =
    selectedBudgetDoc || budgetDocsSelectedFromProp || "";
  const { startPolling, stopPolling } = usePolling();
  const { loanState } = loanDetails;
  const { tasks } = useSelector<RootState, any>((state) => state.TasksStore);
  const [isOngoingDraws, setIsOngoingDraws] = useState<boolean>(false);
  // let { isBudgetRedoDisabled } = useSelector<RootState, DrawRequestStore>(
  //   (state) => state.drawRequestStore
  // );

  const { budgetReviewStatus } = budgetReviewHeader;
  const isReadOnlyViewer = isPurchasedLoansViewerReadOnly();
  const isPLDDrawManagerOrDrawMember =
    isRole(DrawRolesEnum.DRAW_MEMBER) || isRole(DrawRolesEnum.DRAW_MANAGER);
  const isFirstApprovalAssignee =
    budgetApprovalHistory?.length > 0 &&
    isLoginPartyId(budgetApprovalHistory[0].assigneePartyId);
  const isFirstReviewAssignee =
    budgetStatusHistory?.length > 0 &&
    isLoginPartyId(budgetStatusHistory[0].assigneePartyId);
  const isApproverOrDrawManagerOrDrawMember =
    isPLDDrawManagerOrDrawMember || isFirstApprovalAssignee;
  const isReviewerOrDrawManagerOrDrawMember =
    isPLDDrawManagerOrDrawMember || isFirstReviewAssignee;
  const isBudgetInReviewStatus = [
    budgetReviewStatusEnum.ReadyForBudgetReview,
    budgetReviewStatusEnum.InProgress
  ].includes(budgetReviewStatus);
  // Only AM_DRAW_MANAGER can act on a budget review opened from the PLD page.
  const isPLDPageWithoutDrawManager =
    isPLDFlow() && !isRole(DrawRolesEnum.DRAW_MANAGER);

  const isPLDView = Boolean(budgetDocsSelected) && isPLDFlow();

  const showResumeWork =
    !isReadOnlyViewer && budgetReviewStatus === budgetReviewStatusEnum.Hold;

  const showApproveBttn = isApproverOrDrawManagerOrDrawMember;

  const isDisabled = isPLDDrawManagerOrDrawMember
    ? false
    : !(isFirstReviewAssignee && isBudgetInReviewStatus);

  const isApprovalDisabled =
    isPLDDrawManagerOrDrawMember ||
    isFirstApprovalAssignee ||
    isFirstReviewAssignee
      ? !isBudgetInReviewStatus
      : true;

  const { showReadyForReview, isApprovalView, isFieldsDisabled } =
    useMemo(() => {
      if (isReadOnlyViewer || isPLDPageWithoutDrawManager) {
        // Read-only viewers and non draw-manager users landing from the PLD
        // page can never edit or act on the budget.
        return {
          showReadyForReview: false,
          isApprovalView: false,
          isFieldsDisabled: true
        };
      }
      if (
        editableStatuses?.includes(budgetReviewStatus) &&
        isReviewerOrDrawManagerOrDrawMember
      ) {
        return {
          showReadyForReview: true,
          isApprovalView: false,
          isFieldsDisabled: false
        };
      }
      if (
        approvalStatuses?.includes(budgetReviewStatus) &&
        isApproverOrDrawManagerOrDrawMember
      ) {
        return {
          showReadyForReview: false,
          isApprovalView: true,
          isFieldsDisabled: false
        };
      }
      if (
        disableStatuses?.includes(budgetReviewStatus) &&
        isApproverOrDrawManagerOrDrawMember
      ) {
        return {
          showReadyForReview: false,
          isApprovalView: true,
          isFieldsDisabled: true
        };
      }
      return {
        showReadyForReview: isReviewerOrDrawManagerOrDrawMember,
        isApprovalView: false,
        isFieldsDisabled: true
      };
    }, [
      isReadOnlyViewer,
      isPLDPageWithoutDrawManager,
      budgetReviewStatus,
      isReviewerOrDrawManagerOrDrawMember,
      isApproverOrDrawManagerOrDrawMember
    ]);

  const isRedoDisabled = useMemo(() => {
    if (!budgetDocsSelected || isReadOnlyViewer) return true;
    if (isRole(DrawRolesEnum.DRAW_MANAGER)) return false; // AM-2969: redo stays enabled irrespective of ongoing draws
    if (sessionStorage.getItem("budgetReviewSource") === "ILP Page") {
      return loanState === LoanStatusEnum.Purchased;
    }
    return true;
  }, [budgetDocsSelected, isReadOnlyViewer, loanState]);

  const reviewerApprover = useMemo<{
    reviewerName: string;
    approverName: string;
  }>(() => {
    if (!Object.keys(irQCVMAdminMap).length) {
      return { reviewerName: "", approverName: "" };
    }
    return {
      reviewerName:
        (budgetStatusHistory.length > 0 &&
          irQCVMAdminMap[budgetStatusHistory[0].assigneePartyId]) ||
        "--",
      approverName:
        (budgetApprovalHistory.length > 0 &&
          irQCVMAdminMap[budgetApprovalHistory[0].assigneePartyId]) ||
        "--"
    };
  }, [irQCVMAdminMap, budgetStatusHistory, budgetApprovalHistory]);

  const borrowerOriginator = useMemo<{
    borrowersNames: string;
    originatorName: string;
  }>(() => {
    if (!loanDetails?.originatorInfo) {
      return { borrowersNames: "", originatorName: "" };
    }
    const borrowerNameList = (loanDetails.bridgeLoanBorrowerInformation ?? [])
      .filter(
        (item: { payload: { borrowingEntityName: any; lastName: any } }) =>
          // Filter out undefined and empty string values for borrowingEntityName
          item.payload.borrowingEntityName
      )
      .map((item: { payload: { borrowingEntityName: any; lastName: any } }) => {
        const { borrowingEntityName, lastName } = item.payload;
        return `${borrowingEntityName} ${lastName || ""}`;
      });
    return {
      borrowersNames: borrowerNameList.join(","),
      originatorName: loanDetails.originatorInfo?.accountName
    };
  }, [loanDetails]);

  useEffect(() => {
    if (!loanDetails) return;
    const budgetAmount =
      budgetReviewResponse?.updatedTotalRehabBudget && isPLDView
        ? budgetReviewResponse.updatedTotalRehabBudget
        : budgetReviewResponse?.budgetApprovalStatus === "Approved"
        ? budgetReviewResponse.submittedTotalRehabBudget
        : loanDetails.bridgeLoanEconomics.payload.budgetAmount;

    const financedBudgetAmount =
      loanEvaluationResult.loanResult?.[loanId]?.loanEconomics
        .financedBudgetAmountCalculated ??
      loanDetails.bridgeLoanEconomics.payload.financedBudgetAmount;

    const budgetAmountNumber = convertUSDToNumber(budgetAmount);
    const financedBudgetAmountNumber = financedBudgetAmount;
    if (!budgetAmountNumber) return;
    const FinancedPercent =
      (financedBudgetAmountNumber / budgetAmountNumber) * 100;
    const localBudgetButtonInfo = {
      rehabBudget: convertNumberToUSD(budgetAmount) || budgetAmount,
      financedBudgetAmount: convertNumberToUSD(financedBudgetAmount),
      financedBudgetPercentage: FinancedPercent,
      loanDetailsBudgetAmount:
        loanDetails.bridgeLoanEconomics.payload.budgetAmount
    };
    dispatch(updateBudgetButtonInfo(localBudgetButtonInfo));
  }, [
    loanDetails,
    isPLDView,
    dispatch,
    loanId,
    budgetReviewResponse?.updatedTotalRehabBudget,
    budgetReviewResponse?.budgetApprovalStatus,
    budgetReviewResponse?.submittedTotalRehabBudget,
    loanEvaluationResult
  ]);

  const updateTotalBudgetCB = async (
    newBudget: string,
    updateLineItemProps: any
  ) => {
    const financedBudgetAmount =
      loanEvaluationResult.loanResult?.[loanId]?.loanEconomics
        .financedBudgetAmountCalculated ??
      loanDetails.bridgeLoanEconomics.payload.financedBudgetAmount;
    const newBudgetNumber = convertUSDToNumber(newBudget);
    const financedBudgetAmountNumber = convertUSDToNumber(financedBudgetAmount);
    if (!newBudgetNumber) return;
    try {
      await updateTotalBudgetAPI(loanId, newBudget);
      const FinancedPercent =
        (financedBudgetAmountNumber / newBudgetNumber) * 100;
      const newBudgetButtonInfo = {
        rehabBudget: newBudget,
        financedBudgetAmount,
        financedBudgetPercentage: FinancedPercent,
        loanDetailsBudgetAmount: budgetButtonInfo.loanDetailsBudgetAmount
      };
      dispatch(updateBudgetButtonInfo(newBudgetButtonInfo));
      if (redoValidationItems.length === 0) {
        // update all * by FinancedPercent
      } else {
        const {
          budgetDocumentInfoList,
          totalCalculatedData,
          lineItemObj,
          docId
        } = updateLineItemProps;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        handleLineItemOnBlur(
          lineItemsList,
          () => {},
          budgetDocumentInfoList,
          totalCalculatedData,
          lineItemObj,
          docId,
          undefined,
          false
        );
        // let balanceAmount: number = 0;
        // let totalRemainingBudget: number = 0;
        // let newFinancedItemList: any[] = [];
        // let totalBudget = 0;
        // let totalDisbursedAmount = 0;
        // lineItemsList.forEach((item) => {
        //   const remainingFinance =
        //     Number(convertUSDToNumber(item.budget)) -
        //     Number(item.minBudgetAllowed);
        //   totalBudget = totalBudget + Number(convertUSDToNumber(item.budget));
        //   totalDisbursedAmount =
        //     totalDisbursedAmount + Number(item.minBudgetAllowed);
        //   balanceAmount = balanceAmount + remainingFinance;

        //   if (isNaN(remainingFinance)) {
        //     console.error("Error in New Calculation..");
        //     return;
        //   }

        //   newFinancedItemList.push({
        //     ...item,
        //     remainingFinance
        //   });
        // });
        // totalRemainingBudget =
        //   convertUSDToNumber(newBudgetButtonInfo.financedBudgetAmount) -
        //   totalDisbursedAmount;
        // totalBudget - totalDisbursedAmount;
        // dispatch(setBalanceDisbursedAmount(balanceAmount));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const budgetButtonInfoRef = useRef(budgetButtonInfo);

  useEffect(() => {
    budgetButtonInfoRef.current = budgetButtonInfo;
  }, [budgetButtonInfo]);

  const getCommentsDataAndBudgetDataV2 = async (
    selectedBudgetDocId: number,
    selectedBudgetData: any,
    newReviewResponse?: any
  ) => {
    try {
      dispatch(showLoader());
      const resp = await getCommentsList(`${selectedBudgetDocId}`);
      dispatch(hideLoader());
      let selectedPropId = "";
      let redoItems = [];
      if (selectedBudgetDoc?.assets) {
        selectedBudgetDoc.assets.filter((item: any) => {
          if (item.assetName === "PROPERTY") {
            selectedPropId = item.assetExternalId;
          }
        });
      }
      if (redoValidationItems[selectedPropId]) {
        redoItems = redoValidationItems[selectedPropId];
      } else {
        redoItems = await getRedoValidationItems(
          loanId,
          selectedPropId,
          dispatch
        );
      }
      dispatch(
        getBudgetReviewDataV2(
          resp,
          selectedBudgetData.budgetLineItemList,
          budgetButtonInfoRef.current.financedBudgetPercentage,
          propertyDetails,
          budgetExtractionGetResponse,
          budgetChatsData,
          redoItems,
          budgetReviewHeader,
          newReviewResponse || budgetReviewResponse,
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          selectedBudgetData.isRedoInProcess ? getRedoValidationCB : undefined
        )
      );
    } catch (e) {
      console.error(e);
      dispatch(hideLoader());
    }
  };

  // getCommentsDataAndBudgetDataV2 and getRedoValidationCB call each other, so
  // neither can be memoised. Effects reach the latest closure through this ref
  // instead of re-running whenever the component re-renders.
  const getCommentsDataAndBudgetDataV2Ref = useRef(
    getCommentsDataAndBudgetDataV2
  );

  useEffect(() => {
    getCommentsDataAndBudgetDataV2Ref.current = getCommentsDataAndBudgetDataV2;
  });

  useEffect(() => {
    if (Object.keys(irQCVMAdminMap).length) return;
    getListOfAssignee([
      InternalRolesEnum.LAT_IR,
      InternalRolesEnum.LAT_QC,
      InternalRolesEnum.LAT_VM,
      InternalRolesEnum.LAT_ADMIN,
      InternalRolesEnum.LAT_APPROVER,
      InternalRolesEnum.LAT_INQUIRY
    ]).then((res: any) => {
      dispatch(setILPUserList(res.data));
    });
  }, [irQCVMAdminMap, dispatch]);

  useEffect(() => {
    const history = [...budgetApprovalHistory, ...budgetStatusHistory];
    if (!history.length) return;
    async function fetchDetails() {
      let uniqueUser = [...new Set(history.map((item) => item.assignedBy))];
      uniqueUser = uniqueUser.filter(
        (item) =>
          ![
            "System",
            "UnAssigned",
            "None",
            "Merchants Team Member",
            null,
            ""
          ].includes(item)
      );
      try {
        const data = await getUserDetails({ partyIds: uniqueUser });
        let userData: any = {};
        data.forEach((item: any) => {
          userData = {
            ...userData,
            ...{
              [item.partyId]: {
                firstName: item.firstName,
                lastName: item.lastName
              }
            }
          };
        });
        setUserIdMapping(userData);
      } catch (e) {
        console.error(e);
        setUserIdMapping({
          UnAssigned: {
            firstName: "undefined",
            lastName: "undefined"
          }
        });
      }
    }
    fetchDetails();
  }, [budgetStatusHistory, budgetApprovalHistory]);

  useEffect(() => {
    if (!propertyDetails.length) return;
    const { street_line, state, city, zipcode } =
      propertyDetails[0].propertyLocation.payload.address;
    const selectedPropInfo = {
      addressLine1: street_line,
      state,
      city,
      postalCode: zipcode
    };
    dispatch(
      updateSelectedPropDetails({
        selectedPropInfo,
        selectedPropId: propertyDetails[0].loanPropertyOrder
      })
    );
  }, [propertyDetails, dispatch]);

  useEffect(() => {
    if (!loanId) return;
    const reqBody = {
      resourceIds: [loanId],
      resourceTypes: ["LOAN"],
      taskNames: [
        taskNames.TAG,
        taskNames.SPLIT,
        taskNames.REVIEW,
        taskNames.RECONCILE,
        taskNames.BUDGET_REVIEW,
        taskNames.BUDGET_APPROVE
      ]
    };
    dispatch(getBudgetHistory(reqBody, loanId));
  }, [loanId, dispatch]);

  useEffect(() => {
    // updatePropertyDetails
    if (budgetDocs.length === 0) return;
    if (!budgetReviewHeader?.selectedPropId) return;
    const selectDocs = budgetDocs.find((pr: any) =>
      pr.assets.find(
        (it: any) =>
          String(it.assetExternalId) ===
          String(budgetReviewHeader?.selectedPropId)
      )
    );
    dispatch(setSelectedBudgetDoc(selectDocs));
  }, [
    budgetDocs,
    budgetApprovalHistory,
    budgetReviewHeader?.selectedPropId,
    dispatch
  ]);

  function getDrawDetails() {
    const isOrig = isOrigUser();
    const payload = {
      tableFilterConfig: {
        stage: [
          "Draw Submitted",
          "Initial Approval",
          "Final Approval",
          "In Progress",
          // "Wire Unsuccessful",
          "Hold",
          "Draw In Queue"
          // "Originator Pending"
        ]
      },
      tableSearchConfig: {
        toorakLoanId: loanId
      },
      tableSortConfig: {
        drawId: "DESC"
      },
      globalSearch: "",
      pageLimit: 25,
      page: 1
    };
    const cb = (drawsCount: number) => {
      if (drawsCount == 0) {
        setIsOngoingDraws(false);
      } else {
        setIsOngoingDraws(true);
      }
    };
    dispatch(getDrawRequestData(payload, isOrig, 1, 25, cb));
  }

  const getDrawDetailsRef = useRef(getDrawDetails);

  useEffect(() => {
    getDrawDetailsRef.current = getDrawDetails;
  });

  useEffect(() => {
    if (!isRole(DrawRolesEnum.DRAW_MANAGER)) {
      // setIsOngoingDraws(true);
      return;
    }
    getDrawDetailsRef.current();
  }, []);

  const getLoanResults = useCallback(async () => {
    if (!loanDetails) return;
    try {
      const resp: any = await getPropertyOriginalValuesByLoanId(
        loanId,
        loanStage
      );
      const formattedPropertyData = formatPropertyResponse(
        resp?.data,
        loanStage,
        loanType
      );
      dispatch(
        getRuleEvaluationByLoanId(
          loanId,
          loanStage as LoanStage,
          "null",
          true,
          formattedPropertyData,
          loanType,
          true
        )
      );
    } catch (err) {
      console.error("evaluateLoanSuccess", err);
    }
  }, [loanDetails, loanId, loanStage, loanType, dispatch]);

  const hasLoanEconomics = Boolean(
    loanEvaluationResult.loanResult?.[loanId]?.loanEconomics
  );

  useEffect(() => {
    if (!loanDetails || hasLoanEconomics) return;
    getLoanResults();
  }, [loanDetails, hasLoanEconomics, getLoanResults]);

  useEffect(() => {
    if (!(loanId && loanStage)) return;
    getDataByLoanID(loanId, loanStage, dispatch);
    getPropDataByLoanID(loanId, loanStage, loanType, dispatch);
    // dispatch(getBulkBudgetReviewDatav2(loanId, ()=>{}));
  }, [loanId, loanStage, loanType, dispatch]);

  useEffect(() => {
    if (!budgetDocsSelectedFromProp) return;
    if (selectedBudgetDoc?.id === budgetDocsSelectedFromProp.id) return;
    dispatch(setSelectedBudgetDoc(budgetDocsSelectedFromProp));
  }, [
    budgetDocsSelectedFromProp,
    budgetApprovalHistory,
    selectedBudgetDoc?.id,
    dispatch,
    isLineItemsEditDisable
  ]);

  const getBudgetDocs = async () => {
    try {
      const [prePurchaseList, postCloseList] = (await Promise.all([
        getDocuments(
          loanId,
          `${loanStage}-prePurchase`,
          `${loanStage}-prePurchase`,
          loanState,
          true
        ) as any,
        getDocuments(
          loanId,
          `${loanStage}-postClose`,
          `${loanStage}-postClose`,
          loanState
        )
      ])) as any;

      const fetchedBudgetDocs = filterObjectsByTag([
        ...postCloseList.response.data,
        ...prePurchaseList.response.data
      ]);
      if (fetchedBudgetDocs.length) {
        const tempBudgetFilesList = fetchedBudgetDocs.map((fileData) => {
          const fileName = String(fileData.name ?? "");
          const fileType = fileName.split(".").pop()?.toLowerCase();
          return {
            ...fileData,
            fileType,
            title: fileName
          };
        });
        setBudgetDocs(tempBudgetFilesList);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (
      !selectedBudgetDoc?.id ||
      extractionStatus.processState === "Data Loading"
    )
      return;
    if (ExtractionInProgressState?.includes(extractionStatus.processState))
      return;
    dispatch(
      getBudgetData(
        loanId,
        selectedBudgetDoc.id,
        getCommentsDataAndBudgetDataV2Ref.current
      )
    );
  }, [loanId, selectedBudgetDoc, extractionStatus, dispatch]);

  async function handleItemDelete(payload: any[]) {
    try {
      dispatch(showLoader());
      const resp = await deleteLineItems(payload, loanId);
      dispatch(hideLoader());
      return Promise.resolve(resp);
    } catch (err) {
      console.error(err);
      dispatch(hideLoader());
      return Promise.reject(err);
    }
  }

  const {
    Approved,
    // Rejected,
    InProgress,
    // ReadyForBudgetApproval,
    Hold
  } = budgetReviewStatusEnum;

  const updateWithEmptyLineItems = useCallback(
    (response?: any, newState?: ExtractionProcessState, cb?: any) => {
      // function cb(resp: any) {
      //   let formattedLineItems = JSON.parse(
      //     JSON.stringify([...resp.extractedInfoProcessed.lineItems])
      //   );
      //   for (const item of formattedLineItems) {
      //     item.budget = `$${item.budget}.00`;
      //   }
      //   setFieldsData(formattedLineItems);
      //   // setIsManualEntry(true);
      // }
      const newLineItems = addEmptyLineItems({ val: 10 }, [], true);
      updatePredictionStatus(
        response || budgetReviewResponse,
        newState ||
          (response
            ? response.processState
            : budgetReviewResponse.processState),
        newLineItems,
        dispatch,
        cb
      );
    },
    [budgetReviewResponse, dispatch]
  );

  const onPollSuccess = (response: any, isManualEntry: boolean) => {
    setExtractionStatus({
      processState: response[0]?.processState,
      externalDocumentId: response[0]?.externalDocumentId
    });
    setBudgetExtractionGetResponse(response[0]);
    if (
      ExtractionInProgressState.includes(response[0]?.processState) &&
      isManualEntry
    ) {
      stopPolling();
    }
    if (ExtractionInProgressState?.includes(response[0]?.processState)) {
      return true; // Continue polling
    }
    // when status moved to prediction completed
    stopPolling();
    if (isManualEntry) {
      updateWithEmptyLineItems();
    } else {
      getBudgetDocs();
    }
    return undefined;
    // if (
    //   response.budgetDocumentInfoList &&
    //   response.budgetDocumentInfoList[0]?.budgetLineItems?.length
    // ) {
    //   // updateLineReduxData(
    //   //   response,
    //   //   dispatch,
    //   //   budgetButtonInfo.financedBudgetPercentage,
    //   //   // commentsList,
    //   //   true
    //   // );
    //   // dispatch(setBudgetGetResponse(response));
    // } else {
    //   updateWithEmptyLineItems();
    // }
  };

  const onPollTimeExceed = () => {
    console.error("Polling time exceed");
  };

  const startPollingExcecution = (isManualEntry: boolean) => {
    const url = `${
      getConfig().apiUrl
    }/ocr/extraction/${loanId}/documents?tags=REBD,SCOW`;
    startPolling({
      url,
      method: "GET",
      interval: 3000,
      onSuccess: (res) => onPollSuccess(res.data, isManualEntry),
      onExceedingPollingWaitTime: () => {
        onPollTimeExceed();
      },
      pollingWaitTime: 300000 // allow 5 minutes polling
    });
  };

  // startPolling/stopPolling from usePolling are re-created on every render, so
  // the bootstrap effect below reads these through a ref to keep firing only
  // when the loan or its properties change.
  const bootstrapRef = useRef({ startPollingExcecution, getBudgetDocs });

  useEffect(() => {
    bootstrapRef.current = { startPollingExcecution, getBudgetDocs };
  });

  useEffect(() => {
    if (!loanId) return;
    if (!propertyDetails.length) return;
    bootstrapRef.current.startPollingExcecution(false);
    bootstrapRef.current.getBudgetDocs();
  }, [loanId, propertyDetails]);

  function handlePropTypeClickCB(
    title: any,
    fieldsData: any,
    lineItemObj: any
  ) {
    const payload = {
      budgetDocumentInfoId: lineItemObj.budgetDocumentInfoId,
      selectionMode: lineItemObj.selectionMode.toUpperCase()
    };
    updateSelectionMode(lineItemObj.DocumentId, payload);
  }

  function handleCommonTaskUpdate(
    taskList: any[],
    statusHistory: any[],
    approvalHistory: any[],
    header: string,
    showCommentPopup: any,
    _isFirstApprovalAssigneePartyId?: boolean
  ) {
    const userId = getCookie("person_id") || "";
    const updatedTasks = JSON.parse(JSON.stringify(taskList || []));

    const reviewAssignedBy = getAssignedBy(
      updatedTasks,
      taskNames.BUDGET_REVIEW,
      userId
    );
    const approveAssignedBy = getAssignedBy(
      updatedTasks,
      taskNames.BUDGET_APPROVE,
      userId
    );

    const statusMap: any = {
      "Budget Mismatch": InProgress,
      Hold,
      "In-Progress": InProgress,
      "Redo Budget Review": InProgress
    };

    let taskStatus;
    // if (header === "Budget Review Comment") {
    //   taskStatus = ReadyForBudgetApproval;
    // } else if (header === "Redo Budget Review") {
    //   taskStatus = InProgress;
    // } else
    if (Object.prototype.hasOwnProperty.call(statusMap, header)) {
      taskStatus = statusMap[header];
    } else {
      taskStatus = Approved;
    }

    const assignedReviewTasksObj = buildTaskObject(
      "budgetReview",
      reviewAssignedBy,
      statusHistory[0].assigneePartyId,
      taskStatus,
      statusHistory[0].taskId,
      showCommentPopup.comment
    );
    const assigneePartyId =
      approvalHistory[0].assigneePartyId === "UnAssigned"
        ? getCookie("person_id")
        : approvalHistory[0].assigneePartyId;
    const assignedApproveTasksObj = buildTaskObject(
      "budgetApprove",
      approveAssignedBy,
      assigneePartyId,
      header === "Redo Budget Review"
        ? budgetApproveStatusEnum.Pending
        : budgetApproveStatusEnum.Approved,
      approvalHistory[0].taskId,
      showCommentPopup.comment
    );
    return {
      assignedReviewTasksObj,
      assignedApproveTasksObj
    };
  }
  async function handleStatusUpdate(
    header: string,
    showCommentPopup: any,
    _updatedTotalRehabBudget?: any
  ) {
    const { assignedReviewTasksObj, assignedApproveTasksObj } =
      handleCommonTaskUpdate(
        tasks,
        budgetStatusHistory,
        budgetApprovalHistory,
        header,
        showCommentPopup
      );
    const propertyData = loanDetails.propertyDetails?.map((prop: any) => ({
      propertyId: prop.propertyId,
      zipcode: prop.propertyLocation?.payload?.zipCode,
      addressLine1: prop.propertyLocation?.payload?.address?.street_line,
      ...prop.propertyLocation?.payload
    }));
    const payload = {
      budgetApprovalStatus: assignedReviewTasksObj.taskStatus,
      approvedBy: assignedApproveTasksObj.assignedBy,
      reviewedBy: assignedReviewTasksObj.assignedBy,
      propertyData,
      primaryLoanId: loanDetails?.bridgeLoanInformation?.payload?.primaryLoanID
    };
    try {
      await updateBudgetStatusV2(loanId, payload, dispatch);
      dispatch(
        updateStatusOnTask(
          loanId,
          [assignedReviewTasksObj, assignedApproveTasksObj],
          budgetStatusHistory,
          budgetApprovalHistory
        )
      );
      if (["Approval Comment", "Rejection Comment"].includes(header)) {
        if (selectedBudgetDoc) {
          dispatch(
            getBudgetData(
              loanId,
              selectedBudgetDoc.id,
              getCommentsDataAndBudgetDataV2
            )
          );
        }
      }
      return Promise.resolve();
    } catch {
      return Promise.reject();
    }
  }

  async function calculateAndUpdate(
    selectedPropId: string,
    updatedLineItems: any[],
    newBudgetReviewResponse?: any
  ) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const prevDrawData = await getPrevDrawInfoOnly(selectedPropId);
    if (prevDrawData.length == 0) {
      const lineItems = updatedLineItems.map((item: any) => {
        const tempItem = {
          ...item,
          financedBudget: convertNumberToUSD(
            (convertUSDToNumber(item.budget) *
              budgetButtonInfo.financedBudgetPercentage) /
              100
          )
        };
        return tempItem;
      });
      dispatch(updateLineItemList(lineItems));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const newData = await getUpdatedPrevDrawInfo(
        selectedPropId,
        updatedLineItems
      );

      const newLineItems = calculateNewFinancedBudget(
        newData.formattedData,
        newBudgetReviewResponse || budgetReviewResponse,
        budgetButtonInfo
      );
      dispatch(updateLineItemList(newLineItems));
    }
  }

  /**
   * For version change and property change flow
 
   */
  async function addExistingCommentsAndRedoValidation(
    lineObject: any[],
    isRedoValidationReq: boolean,
    newBudgetChatsData: any,
    newPropertyId?: string
  ) {
    const lineItemsWithoutChats: any[] = [];
    let updatedWithComments: any[] = [];
    lineObject.forEach((item) => {
      // for AM-2527
      const isPLDSource = isPLDFlow();
      const newFnancedBudget =
        convertUSDToNumber(item.financedBudget) === 0
          ? isPLDSource
            ? item.budget
            : (item.budget * budgetButtonInfo.financedBudgetPercentage) / 100
          : item.financedBudget;
      if (item.commentThreadId && newBudgetChatsData[item.commentThreadId]) {
        updatedWithComments.push({
          ...item,
          comments: newBudgetChatsData[item.commentThreadId],
          financedBudget: newFnancedBudget
        });
      } else if (
        item.commentThreadId &&
        !newBudgetChatsData[item.commentThreadId]
      ) {
        lineItemsWithoutChats.push({
          ...item,
          financedBudget: newFnancedBudget
        });
      } else {
        updatedWithComments.push({ ...item, financedBudget: newFnancedBudget });
      }
      // return item;
    });
    if (lineItemsWithoutChats?.length) {
      const missingComments = await mergeChatDetails(
        lineItemsWithoutChats,
        newBudgetChatsData,
        dispatch
      );
      updatedWithComments = [...missingComments, ...updatedWithComments];
    }
    if (isRedoValidationReq) {
      if (newPropertyId && updatedWithComments.length) {
        calculateAndUpdate(newPropertyId, updatedWithComments);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getRedoValidationCB(updatedWithComments, undefined, newPropertyId);
      }
    } else {
      dispatch(updateLineItemList(updatedWithComments));
    }
  }

  async function getPreviousVersionDataCB(
    version: string,
    isLatestVersion: boolean,
    budgetDocSelected: any
  ) {
    const lineObject = await getPreviousVersionData(
      budgetDocSelected.id,
      version,
      budgetButtonInfo.financedBudgetPercentage,
      dispatch
    );
    addExistingCommentsAndRedoValidation(
      lineObject,
      isLatestVersion,
      budgetChatsData
    );
  }

  function handleRedoCallBack(budgetDocSelected?: any) {
    const finalBudgetDoc = budgetDocSelected ?? selectedBudgetDoc;
    if (finalBudgetDoc) {
      dispatch(
        getBudgetData(loanId, finalBudgetDoc.id, getCommentsDataAndBudgetDataV2)
      );
    }
  }

  // handleRedoBudgetCB using the helper
  async function handleRedoBudgetCB(
    isFirstApprovalAssigneePartyId: boolean,
    showCommentPopup: any,
    budgetDocSelected: any,
    fieldsData: any,
    selectedProperties: any,
    triggerCalculation?: boolean
  ) {
    const docId = budgetDocSelected.documentId || budgetDocSelected.id;
    const budgetDocumentInfoList = updateFieldName(budgetPropData);
    const lineItemObj = budgetDocumentInfoList.filter(
      (data) =>
        Number(data.documentId) === budgetDocSelected?.documentId ||
        Number(data.DocumentId) === budgetDocSelected?.id
    )[0];
    const { assignedReviewTasksObj, assignedApproveTasksObj } =
      handleCommonTaskUpdate(
        tasks,
        budgetStatusHistory,
        budgetApprovalHistory,
        showCommentPopup.headerText,
        showCommentPopup,
        isFirstApprovalAssigneePartyId
      );
    try {
      if (!budgetDocSelected?.id) {
        console.error("Budget Doc id not found..", {
          budgetDocSelected,
          budgetDocsSelected
        });
        return Promise.reject("Budget Doc id not found..");
      }
      let selectedPropId = "";
      let lineItems = fieldsData?.length ? fieldsData : lineItemsList;
      const isPLDSource = isPLDFlow();
      const budgetLines = budgetPropData?.find(
        (budget: any) => budget.externalDocumentId == docId
      );
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const prevDrawData = await getPrevDrawInfoOnly(budgetLines.propertyId);

      if (
        (lineItemObj?.isRedoInProcess &&
          isPLDSource &&
          prevDrawData.length > 0) ||
        triggerCalculation
      ) {
        const newFieldsData: any[] = [];
        const RedoLineItemsList: any[] = budgetDocumentInfoList?.filter(
          (key1: any) => {
            if (
              key1.budgetDocumentInfoId === lineItemObj.budgetDocumentInfoId
            ) {
              fieldsData.forEach((line: any) => {
                newFieldsData.push({
                  ...line,
                  budgetDocumentInfoId: lineItemObj.budgetDocumentInfoId
                });
              });
            }
            return key1.isRedoInProcess;
          }
        );
        if (RedoLineItemsList.length > 1) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          lineItems = await handleMultiPropertyRedo(
            RedoLineItemsList,
            lineItemObj,
            newFieldsData,
            budgetReviewResponse
          );
        } else {
          let noMinBudgetVal = true;
          for (const item of lineItems) {
            if ("minBudgetAllowed" in item && item.minBudgetAllowed !== 0) {
              noMinBudgetVal = false;
              break;
            }
          }
          if (noMinBudgetVal) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            const newData = await getUpdatedPrevDrawInfo(
              budgetLines.propertyId,
              lineItems
            );
            lineItems = calculateNewFinancedBudget(
              newData.formattedData,
              budgetReviewResponse,
              budgetButtonInfo,
              triggerCalculation
            );
          } else {
            lineItems = calculateNewFinancedBudget(
              lineItems,
              budgetReviewResponse,
              budgetButtonInfo,
              triggerCalculation
            );
          }
        }
      } else {
        // check if excel upload, calculate again here
        lineItems = lineItems.map((item: any) => {
          const tempItem = {
            ...item,
            budget: convertUSDToNumber(item.budget)?.toFixed(2),
            financedBudget: (
              (convertUSDToNumber(item.budget) *
                budgetButtonInfo.financedBudgetPercentage) /
              100
            )?.toFixed(2)
          };
          return tempItem;
        });
      }

      if (budgetDocSelected?.assets) {
        budgetDocSelected.assets.filter((item: any) => {
          if (item.assetName === "PROPERTY") {
            selectedPropId = item.assetExternalId;
          }
        });
      }

      const budgetLineItemMap: any = {};
      [selectedProperties]?.forEach((prop: any) => {
        const budgetedDoc = budgetDocs.find((pr: any) =>
          pr.assets.find(
            (it: any) =>
              String(it.assetExternalId) === String(prop?.propertyId)
          )
        );
        if (budgetedDoc?.id) {
          if (budgetedDoc?.id === budgetDocSelected?.id) {
            budgetLineItemMap[budgetedDoc.id] = triggerCalculation
              ? [...lineItems].map((item: any) => {
                  const tempItem = {
                    ...item,
                    budget: convertUSDToNumber(item.budget)?.toFixed(2),
                    financedBudget:
                      typeof item.financedBudget === "number"
                        ? item.financedBudget
                        : convertUSDToNumber(item.financedBudget).toFixed(2)
                  };
                  return tempItem;
                })
              : lineItems;
          } else {
            budgetLineItemMap[budgetedDoc.id] =
              budgetPropData?.find(
                (bPropData: any) => bPropData.propertyId == prop?.propertyId
              )?.budgetLineItemList ?? [];
          }
        }
      });
      const payload = {
        propertyIds: showCommentPopup.extraInfo,
        budgetLineItemMap: { ...budgetLineItemMap }
      };
      await redoBudgetReview(
        loanId,
        payload,
        selectedPropId,
        dispatch,
        // getRedoValidationCB
        handleRedoCallBack,
        budgetDocSelected
      );
      dispatch(setSelectedBudgetDoc(budgetDocSelected));

      dispatch(
        updateStatusOnTask(
          loanId,
          [assignedReviewTasksObj, assignedApproveTasksObj],
          budgetStatusHistory,
          budgetApprovalHistory
        )
      );
      if (isPLDFlow() && triggerCalculation) {
        setTimeout(() => window.location.reload(), 1000);
        return undefined;
      }
      return Promise.resolve(lineItems);
    } catch (e) {
      console.error(e);
      return Promise.reject();
    }
  }

  const getRedoValidationCB = async (
    updatedLineItems: any[],
    propertyViewData?: any,
    newPropertyId?: string,
    newBudgetReviewResponse?: any
  ) => {
    if (!updatedLineItems?.length) {
      if (selectedBudgetDoc) {
        dispatch(
          getBudgetData(
            loanId,
            selectedBudgetDoc.id,
            getCommentsDataAndBudgetDataV2
          )
        );
      }
      return;
    }
    if (propertyViewData) {
      // update available versions dropdown
      const selectedBudgetPropData = {
        ...budgetPropData.find(
          (data: any) => data.externalDocumentId == budgetDocsSelected?.id
        )
      };
      const availableVersions = [
        ...(selectedBudgetPropData?.availableVersions || []),
        propertyViewData.version.toString()
      ];
      const updatedPropertyViewData = {
        ...propertyViewData,
        ...{
          availableVersions
        }
      };
      const newBudgetPropData = budgetPropData.map((obj: any) =>
        obj.externalDocumentId == budgetDocsSelected?.id
          ? updatedPropertyViewData
          : obj
      );
      dispatch(updateBudgetPropData(newBudgetPropData));
    }
    let selectedPropId = "";
    if (newPropertyId) {
      selectedPropId = newPropertyId;
    } else if (selectedBudgetDoc?.assets) {
      selectedBudgetDoc.assets.filter((item: any) => {
        if (item.assetName === "PROPERTY") {
          selectedPropId = item.assetExternalId;
        }
      });
    }
    if (!selectedPropId) return;
    const newTotalRehabBudget =
      newBudgetReviewResponse?.updatedTotalRehabBudget ??
      budgetReviewResponse?.updatedTotalRehabBudget;
    const isPLDSource = isPLDFlow();
    if (newTotalRehabBudget && isPLDSource)
      calculateAndUpdate(
        selectedPropId,
        updatedLineItems,
        newBudgetReviewResponse
      );
    else {
      try {
        let noFBVal = false;

        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const newData = await getUpdatedPrevDrawInfo(
          selectedPropId,
          updatedLineItems
        );
        // newData.formattedData.forEach((item)=>{item.financedBudget ==})
        for (const item of newData.formattedData) {
          if (convertUSDToNumber(item.financedBudget) == 0) {
            noFBVal = true;
            break;
          }
        }
        if (noFBVal) {
          calculateAndUpdate(
            selectedPropId,
            updatedLineItems,
            newBudgetReviewResponse
          );
        } else {
          dispatch(updateLineItemList(newData.formattedData));
        }
      } catch {
        dispatch(updateLineItemList(updatedLineItems));
      }
    }
  };

  async function createAndUpdateCommentsCB(
    comments: any[],
    newLineItemsList: any[],
    docsId: string,
    comment: string,
    row: any,
    cb: any
  ) {
    const { newList, newChatData } = await handleAddCommentProceed(
      newLineItemsList,
      docsId,
      comment,
      row,
      comments
    );
    const newbudgetChatsData = { ...budgetChatsData, ...newChatData };
    dispatch(updateBudgetChatsData(newbudgetChatsData));
    if (!row.commentThreadId) {
      dispatch(updateBudgetLineItems(newList, docsId));
    }
    dispatch(updateLineItemList(newList));
    const newBudgetPropData = budgetPropData.map((obj: any) =>
      obj.externalDocumentId == docsId
        ? {
            ...obj,
            ...{
              budgetLineItemList: newList
            }
          }
        : obj
    );
    dispatch(updateBudgetPropData(newBudgetPropData));
    if (cb) {
      cb();
    }
  }

  async function getPrevDrawInfoOnly(selectedPropId: string) {
    try {
      let redoItems: any[] = [];
      if (redoValidationItems[selectedPropId]) {
        redoItems = redoValidationItems[selectedPropId];
      } else {
        redoItems = await getRedoValidationItems(
          loanId,
          selectedPropId,
          dispatch
        );
      }
      return Promise.resolve(redoItems);
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getUpdatedPrevDrawInfo(
    selectedPropId: string,
    updatedLineItems: any[]
  ) {
    const redoItems: any[] = await getPrevDrawInfoOnly(selectedPropId);
    // if (redoValidationItems[selectedPropId]) {
    //   redoItems = redoValidationItems[selectedPropId];
    // } else {
    //   redoItems = await getRedoValidationItems(
    //     loanId,
    //     selectedPropId,
    //     dispatch
    //   );
    // }
    const newData = updateWithPrevDrawData(updatedLineItems, redoItems);
    // dispatch(setBalanceDisbursedAmount(newData.balanceAmount));
    return newData;
  }

  function loaderCB(isShow: boolean) {
    if (isShow) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }

  async function handleMultiPropertyRedo(
    RedoLineItemsList: any[],
    lineItemObj: any,
    editingLineItems: any[],
    budgetReviewResponseData: any
  ) {
    const promises: any[] = [];
    RedoLineItemsList.forEach((propList: any) => {
      const newlineItems =
        lineItemObj.budgetDocumentInfoId === propList.budgetDocumentInfoId
          ? editingLineItems
          : propList.budgetLineItemList;
      const newData = getUpdatedPrevDrawInfo(propList.propertyId, newlineItems);
      promises.push(newData);
    });
    try {
      const newDataWithPrevList: { formattedData: any[] }[] = await Promise.all(
        promises
      );
      const mergedLineItems: any[] = [];
      newDataWithPrevList.forEach((item: any) => {
        mergedLineItems.push(...item.formattedData);
      });
      const newFBLineItems = calculateNewFinancedBudget(
        mergedLineItems,
        budgetReviewResponseData,
        budgetButtonInfo
      );
      const renderedLineItems = newFBLineItems.filter(
        (item: any) => item.budgetDocumentInfoId
      );
      // console.log({ renderedLineItems, newFBLineItems });
      return renderedLineItems;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }
  /**
   * On blur while editing nad Delete line items flow
   
   */
  async function handleLineItemOnBlur(
    fieldsData: any,
    cb: any,
    budgetDocumentInfoList: any,
    totalCalculatedData: any,
    lineItemObj: any,
    docId: string,
    editCheck: any,
    autoSave: boolean
    // budgetTotalInfo: BudgetTotalInfo,
  ) {
    let lineItems = fieldsData?.filter(
      (data: any) =>
        convertUSDToNumber(data.budget) != 0 && data.item.trim() !== ""
    );

    if (
      [
        budgetReviewStatusEnum.LoanSubmitted,
        budgetReviewStatusEnum.ReadyForBudgetReview,
        budgetReviewStatusEnum.DataMismatch
      ].includes(budgetReviewHeader.budgetReviewStatus) &&
      !autoSave
    ) {
      // update status to in progress
      // const updatedTasks: any = JSON.parse(JSON.stringify(tasks));
      // let assignedBy = updatedTasks?.[0]?.assignedTasks.find((task: any) =>
      //   [taskNames.BUDGET_REVIEW].includes(task.taskName)
      // )?.assignedBy;handleLineItemOnBlurCB
      // if (!assignedBy || ["UnAssigned", "None"].includes(assignedBy)) {
      //   assignedBy = userId;
      // }
      // let assignedTasksObj = [
      //   {
      //     op: "replace",
      //     taskName: "budgetReview",
      //     assignedBy,
      //     assigneePartyId: budgetStatusHistory[0].assigneePartyId,
      //     taskStatus: budgetReviewStatusEnum.InProgress,
      //     taskId: budgetStatusHistory[0].taskId,
      //     comment: "Status Updated by System"
      //   }
      // ];

      // const payload = {
      //   budgetApprovalStatus: budgetReviewStatusEnum.InProgress
      // };
      const { payload, assignedTasksObj } = budgetReviewInProgress(
        tasks,
        budgetStatusHistory
      );
      await updateBudgetStatusV2(loanId, payload, dispatch);
      dispatch(
        updateStatusOnTask(loanId, assignedTasksObj, budgetStatusHistory)
      );
    }
    const isPLDSource = isPLDFlow();
    const prevDrawData = await getPrevDrawInfoOnly(lineItemObj.propertyId);
    if (lineItemObj.isRedoInProcess && isPLDSource && prevDrawData.length > 0) {
      const newFieldsData: any[] = [];
      const RedoLineItemsList: any[] = budgetDocumentInfoList?.filter(
        (key1: any) => {
          if (key1.budgetDocumentInfoId === lineItemObj.budgetDocumentInfoId) {
            fieldsData.forEach((line: any) => {
              newFieldsData.push({
                ...line,
                budgetDocumentInfoId: lineItemObj.budgetDocumentInfoId
              });
            });
          }
          return key1.isRedoInProcess;
        }
      );

      if (RedoLineItemsList.length > 1) {
        lineItems = await handleMultiPropertyRedo(
          RedoLineItemsList,
          lineItemObj,
          newFieldsData,
          budgetReviewResponse
        );
      } else {
        let noMinBudgetVal = true;
        for (const item of lineItems) {
          if ("minBudgetAllowed" in item && item.minBudgetAllowed !== 0) {
            noMinBudgetVal = false;
            break;
          }
        }
        if (noMinBudgetVal) {
          // no amount disbursed in previous draws
          const budgetLines = budgetPropData?.find(
            (budget: any) => budget.externalDocumentId == docId
          );
          const newData = await getUpdatedPrevDrawInfo(
            budgetLines.propertyId,
            lineItems
          );
          lineItems = calculateNewFinancedBudget(
            newData.formattedData,
            budgetReviewResponse,
            budgetButtonInfo
          );
        } else {
          lineItems = calculateNewFinancedBudget(
            lineItems,
            budgetReviewResponse,
            budgetButtonInfo
          );
        }
      }
    } else {
      lineItems = lineItems.map((item: any) => {
        const tempItem = {
          ...item,
          financedBudget: convertNumberToUSD(
            (convertUSDToNumber(item.budget) *
              budgetButtonInfo.financedBudgetPercentage) /
              100
          )
        };
        return tempItem;
      });
    }
    async function callBack(response: any) {
      const selectedPropId = lineItemObj.propertyId;
      const budgetLines = response.budgetDocumentInfoList?.find(
        (budget: any) => budget.externalDocumentId == docId
      );
      // let formatttedData = [...budgetLines?.budgetLineItemList];
      const isPLDSourceInCallback = isPLDFlow();
      if (lineItemObj.isRedoInProcess && isPLDSourceInCallback) {
        const newData = await getUpdatedPrevDrawInfo(
          selectedPropId,
          budgetLines.budgetLineItemList
        );
        dispatch(updateLineItemList(newData.formattedData));
      } else {
        dispatch(updateLineItemList(budgetLines?.budgetLineItemList));
      }
      cb();
    }
    dispatch(updateBudgetLineItems(lineItems, docId, true, callBack));
  }

  async function reTriggerBudgetExtractionCB(toorakLoanId: string, cb?: any) {
    try {
      dispatch(showLoader());
      const resp = await reTriggerBudgetExtraction(toorakLoanId, cb);
      await delay(3000); // 3000 is the time to start polling calls
      dispatch(hideLoader());
      return resp;
    } catch (e) {
      dispatch(hideLoader());
      console.error(e);
      return undefined;
    }
  }
  return (
    <LazyBudgetReview
      hideOldBudget
      budgetData={{
        setSelectedBudgetDoc,
        dispatch,
        id: loanId,
        budgetDocs,
        handlePropTypeClickCB,
        budgetChatsData,
        userIdMapping,
        reviewerApprover,
        borrowerOriginator,
        loanDetails,
        budgetReviewHeader,
        BulkBudgetSum,
        budgetButtonInfo,
        budgetApprovalHistory,
        budgetStatusHistory,
        lineItemsList,
        selectedBudgetDoc,
        redoValidationItems,
        reviewHistory: [...budgetStatusHistory],
        budgetDocumentInfoList: budgetPropData
          ? updateFieldName(budgetPropData)
          : [],
        budgetReviewResponse: extractionStatus,
        actionButtonAccess: {
          showReadyForReview,
          showResumeWork,
          isReadyForReviewDisabled: isDisabled,
          isApproveDisabled: isApprovalDisabled,
          // isRejectDisabled,
          isRedoDisabled,
          isActiveDraws: isOngoingDraws,
          showApproveBtn: showApproveBttn,
          isFieldsDisabled,
          isApprovalView,
          isPLDView
        },
        budgetDocsOption: budgetDocs
      }}
      DocumentViewer={{
        DocumentViewerCompo: DocumentViewer,
        budgetDocsSelected,
        DocumentViewerCB: {
          documentReviewDispatch: () => {},
          onChangeHighlightSelect: () => {}
        }
      }}
      budgetCB={{
        isLoginPartyId,
        handleItemDelete,
        createAndUpdateCommentsCB,
        handleRedoBudgetCB,
        updateTotalBudgetCB,
        getPreviousVersionDataCB,
        addExistingCommentsAndRedoValidationCB:
          addExistingCommentsAndRedoValidation,
        handleStatusChangeCB: handleStatusUpdate,
        handleLineItemOnBlurCB: handleLineItemOnBlur,
        startPollingCB: startPollingExcecution,
        loaderCB,
        updatePredictionStatusCB: updateWithEmptyLineItems,
        updateBudgetLineItemsCB: updateBudgetLineItems,
        getRedoValidationCB,
        reTriggerBudgetExtractionCB
      }}
      isPLDFlow={isPLDFlow}
      budgetConstants={{
        budgetReviewStatusConst,
        BudgetApproverStatus,
        ExtractionInProgressState,
        ExtractionProcessState,
        budgetReviewStatusEnum
      }}
      // configList={{
      //   configItems: ConfigItems
      // }}
      budgetModals={{ ConfirmFormModal }}
    />
  );
};
